import React, { createContext, useContext, useState } from 'react';
import ConfirmDialog from '@components/ConfirmDialog';
import AlertDialog from '@components/AlertDialog';

const DialogContext = createContext();

export const useDialog = () => useContext(DialogContext);

export const DialogProvider = ({ children }) => {
  const [isConfirmOpen, setConfirmOpen] = useState(false);
  const [confirmOptions, setConfirmOptions] = useState({});
  const [isAlertOpen, setAlertOpen] = useState(false);
  const [alertOptions, setAlertOptions] = useState({});

  const requestConfirm = ({ message, onConfirm, onCancel }) => {
    setConfirmOptions({ message, onConfirm, onCancel });
    setConfirmOpen(true);
  };

  const requestAlert = ({ message, onClose }) => {
    setAlertOptions({ message, onClose });
    setAlertOpen(true);
  };

  const handleConfirm = () => {
    if (confirmOptions.onConfirm) {
      confirmOptions.onConfirm();
    }
    setConfirmOpen(false);
  };

  const handleCancel = () => {
    if (confirmOptions.onCancel) {
      confirmOptions.onCancel();
    }
    setConfirmOpen(false);
  };

  const handleCloseAlert = () => {
    if (alertOptions.onClose) {
      alertOptions.onClose();
    }
    setAlertOpen(false);
  };

  return (
    <DialogContext.Provider value={{ requestConfirm, requestAlert }}>
      {children}
      <ConfirmDialog
        open={isConfirmOpen}
        message={confirmOptions.message}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
      <AlertDialog
        open={isAlertOpen}
        message={alertOptions.message}
        onClose={handleCloseAlert}
      />
    </DialogContext.Provider>
  );
};
